import BackArrow from '@/app/components/questionnaireV2/icons/back-arrow';

interface InterstitialFooterProps {
  onBack?: () => void;
  isBackDisabled?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export function InterstitialFooter({
  onBack,
  isBackDisabled = false,
  children,
  className = '',
}: InterstitialFooterProps) {
  if (!children && !onBack) return null;

  return (
    <div
      className={`sticky bottom-0 z-20 -mx-6 flex w-[calc(100%+3rem)] shrink-0 justify-center bg-gradient-to-t from-black/80 to-transparent px-5 pb-safe-offset-4 pt-8 ${className}`}
    >
      <div className="flex w-full max-w-lg items-center gap-3">
        {onBack && (
          <button
            onClick={onBack}
            disabled={isBackDisabled}
            className="inline-flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white/60 transition-colors hover:bg-white/20 disabled:opacity-40"
            style={{
              cursor: isBackDisabled ? 'not-allowed' : 'pointer',
              pointerEvents: isBackDisabled ? 'none' : 'auto',
            }}
          >
            <BackArrow />
          </button>
        )}
        {children && (
          <div className="min-w-0 flex-1 [&_button]:w-full [&_button]:rounded-full">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
